import { mesaColorNames } from '@/src/common/theme'
import { Image, ScrollView, StyleSheet, View } from 'react-native'
import { Separator } from 'tamagui'
import { Fragment, type ReactNode } from 'react'

export function PartnerNetworkRow(
  props:
    | { networkImageUrl: string; partnerImageUrls: string[] }
    | { network: ReactNode; partners: ReactNode[] },
) {
  return (
    <View style={styles.container}>
      <Separator style={{ borderColor: mesaColorNames['global/grey/20 #E6E9EB'] }} />
      <View style={styles.logoContainer}>
        <View style={styles.networkImageContainer}>
          {'network' in props ? (
            props.network
          ) : (
            <Image
              source={{ uri: props.networkImageUrl }}
              style={styles.networkImage}
              resizeMode="contain"
            />
          )}
        </View>
        <ScrollView horizontal contentContainerStyle={styles.partnerImageContainer}>
          {'partners' in props
            ? props.partners.map((partner, index) => <Fragment key={index}>{partner}</Fragment>)
            : props.partnerImageUrls.map((url) => (
                <Image
                  key={url}
                  source={{ uri: url }}
                  style={styles.partnerImage}
                  resizeMode="contain"
                />
              ))}
        </ScrollView>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 16,
  },
  logoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  networkImageContainer: {
    width: 64,
    height: 64,
    borderRadius: 8,
    padding: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: mesaColorNames['Mesa - Brand/Blackish #222222'],
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.17,
    shadowRadius: 6,
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
  },
  networkImage: {
    width: '100%',
    height: '100%',
  },
  partnerImageContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  partnerImage: {
    height: 42,
    width: 110,
  },
})
